"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var commons_validator_js_1 = require("commons-validator-js");
var moment = require("moment-timezone"); // BAD
var emailValidator = new commons_validator_js_1.EmailValidator();
var dateRegex = new RegExp('^[0-9]{4}-[0-9]{2}-[0-9]{2}$');
exports.REQUIRED_ERROR = 'formError.requiredError';
exports.EMAIL_ERROR = 'formError.emailError';
exports.PHONE_ERROR = 'formError.phoneError';
exports.DATE_ERROR = 'formError.dateError';
var isValidDate = function (value) { return dateRegex.test(value) && moment(value).isValid(); };
var isDateEmpty = function (value) { return !(value && value.replace(/-/g, '').replace('undefined', '')); };
exports.required = function (value) { return (value ? undefined : exports.REQUIRED_ERROR); };
exports.arrRequired = function (value) { return (value && value.length ? undefined : exports.REQUIRED_ERROR); };
exports.email = function (value) {
    return !value ? exports.REQUIRED_ERROR : emailValidator.isValid(value) ? undefined : exports.EMAIL_ERROR;
};
exports.phoneRequired = function (value) { return (!value ? exports.REQUIRED_ERROR : exports.phone(value)); };
exports.phone = function (value) { return (!value || /^[0-9()+\-\s]{0,25}$/.test(value) ? undefined : exports.PHONE_ERROR); };
exports.fullAddressRequired = function (value) {
    var errors = [];
    for (var i = 0; i < 5; i++) {
        if (!value || !value[i]) {
            errors[i] = exports.REQUIRED_ERROR;
        }
    }
    return errors.length ? errors : undefined;
};
exports.shortAddressRequired = function (value) { return (value && value[0] ? undefined : [exports.REQUIRED_ERROR]); };
exports.dateRequired = function (value) { return (isDateEmpty(value) ? exports.REQUIRED_ERROR : exports.date(value)); };
exports.date = function (value) { return (isDateEmpty(value) || isValidDate(value) ? undefined : exports.DATE_ERROR); };
exports.guestNamesRequired = function (_a) {
    var additionalGuests = _a.additionalGuests, guestNames = _a.guestNames;
    var errors = [];
    for (var i = 0; i < additionalGuests; i++) {
        if (!(guestNames[i] && guestNames[i].firstName)) {
            errors[i] = errors[i] || {};
            errors[i].firstName = exports.REQUIRED_ERROR;
        }
        if (!(guestNames[i] && guestNames[i].lastName)) {
            errors[i] = errors[i] || {};
            errors[i].lastName = exports.REQUIRED_ERROR;
        }
    }
    return errors.length ? errors : undefined;
};
exports.FORM_FIELD_VALIDATION = {
    input: function (field) {
        if (field.name.includes('email')) {
            return exports.email;
        }
        else if (field.name.includes('phone')) {
            return field.mandatory ? exports.phoneRequired : exports.phone;
        }
        else {
            return field.mandatory ? exports.required : undefined;
        }
    },
    textarea: function (field) { return (field.mandatory ? exports.required : undefined); },
    dropdown: function () { return undefined; },
    radio: function () { return undefined; },
    checkbox: function (field) { return (field.mandatory ? exports.arrRequired : undefined); },
    address: function (field) { return (field.mandatory ? (field.full ? exports.fullAddressRequired : exports.shortAddressRequired) : undefined); },
    date: function (field) { return (field.mandatory ? exports.dateRequired : exports.date); },
    guestsControl: function (field) { return (field.requireGuestNames ? exports.guestNamesRequired : undefined); }
};
exports.validate = function (values) { return ({
    firstName: exports.required(values.firstName),
    lastName: exports.required(values.lastName)
}); };
